import { useMemo, useState, type PropsWithChildren } from 'react'

import { getPeriodRange, type DateRange, type Period } from '@/shared/lib/period'

import { PeriodContext, type PeriodContextValue } from './PeriodContext'

export function PeriodProvider({ children }: PropsWithChildren) {
  // ТЗ п. 3: по умолчанию «За день».
  const [period, setPeriod] = useState<Period>('day')
  const [customRange, setCustomRange] = useState<DateRange>(() => getPeriodRange('custom'))

  const value = useMemo<PeriodContextValue>(() => {
    const range = getPeriodRange(period, new Date(), customRange)
    return {
      period,
      setPeriod,
      customRange,
      setCustomRange,
      range,
      rangeParams: { from: range.from.toISOString(), to: range.to.toISOString(), period },
    }
  }, [period, customRange])

  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>
}
